module.exports = __webpack_public_path__ + "img/566633d.jpg";